import { createRouter, createWebHistory } from 'vue-router';
import IndexPage from '@/components/IndexPage.vue';
import ChapterInfoPage from '@/components/ChapterInfoPage.vue';
import LoginPage from '@/components/LoginPage.vue';
import UserInfoPage from '@/components/UserInfoPage.vue';
import AIAssistantPage from '@/components/AIAssistantPage.vue';
import LearningPage from '@/components/LearningPage.vue';
import VolunteerPage from '@/components/VolunteerPage.vue';
import SearchPage from '@/components/SearchPage.vue';
import { baseUrl, authenticationUrl } from '@/constants/urls.js';
import axios from 'axios';
axios.defaults.withCredentials = true;


// 1. 先创建 router 实例
const router = createRouter({
  history: createWebHistory(),
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: [
    { path: '/', name: 'Home', component: IndexPage, meta: { title : '创善助盲网校' }},
    { path: '/chapters', name: 'ChapterInfo', component: ChapterInfoPage},
    { path: '/AIAssistant', name: 'AIAssistant', component: AIAssistantPage, meta: { requiresAuth: true } },
    { path: '/learning', name: 'Learning', component: LearningPage, meta: { requiresAuth: true } },
    { path: '/volunteer', name: 'Volunteer', component: VolunteerPage, meta: { requiresAuth: true } },
    { path: '/login', name: 'Login', component: LoginPage },
    { path: '/user', name: 'User', component: UserInfoPage, meta: { requiresAuth: true } },
    { path: '/search', name: 'Search', component: SearchPage, meta: { requiresAuth: true } }
  ]
});

// 2. 在 router 实例上添加 beforeEach 守卫
router.beforeEach(async (to, from, next) => {
  if (to.meta && to.meta.title){
    document.title=to.meta.title;
  }
  if (to.meta.requiresAuth) {
    try {
      const response = await axios.get(`${baseUrl}${authenticationUrl}`, {withCredentials: true});
      if (response.data.authenticated) {
        next(); // 用户已登录，放行
      } else {
        next('/login'); // 未登录，跳转到登录页
      }
    } catch (error) {
      console.error('身份验证失败:', error);
      next('/login'); // 认证失败，跳转到登录页
    }
  } else {
    next(); // 不需要认证的路由直接放行
  }
});

// 3. 导出 router 实例
export default router;
